function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "google1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 73 61 L 125.695312 61 L 125.695312 113 L 73 113 Z M 73 61 "
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "google2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 24 82 L 110 82 L 110 125.878906 L 24 125.878906 Z M 24 82 "
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "google3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 18.445312 47 L 43 47 L 43 96 L 18.445312 96 Z M 18.445312 47 "
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "google4"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 24 17.457031 L 110 17.457031 L 110 61 L 24 61 Z M 24 17.457031 "
})));

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "26px",
    viewBox: "0 0 144 143.999998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 72 0 C 32.300781 0 0 32.300781 0 72 C 0 111.699219 32.300781 144 72 144 C 111.699219 144 144 111.699219 144 72 C 144 32.300781 111.699219 0 72 0 Z M 72 0 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(25.878906%,52.159119%,95.689392%)",
      fillOpacity: 1
    },
    d: "M 125.746094 72.871094 C 125.746094 68.414062 125.378906 65.160156 124.589844 61.789062 L 73.238281 61.789062 L 73.238281 81.90625 L 103.382812 81.90625 C 102.773438 86.90625 99.488281 94.433594 92.199219 99.492188 L 92.09375 100.167969 L 108.332031 112.636719 L 109.457031 112.746094 C 119.789062 103.289062 125.746094 89.378906 125.746094 72.871094 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.388794%,65.879822%,32.548523%)",
      fillOpacity: 1
    },
    d: "M 73.238281 125.878906 C 88.003906 125.878906 100.402344 121.0625 109.457031 112.746094 L 92.199219 99.492188 C 87.578125 102.6875 81.382812 104.917969 73.238281 104.917969 C 58.773438 104.917969 46.5 95.460938 42.121094 82.390625 L 41.480469 82.441406 L 24.597656 95.394531 L 24.378906 96 C 33.371094 113.710938 51.847656 125.878906 73.234375 125.878906 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.429871%,73.728943%,1.959229%)",
      fillOpacity: 1
    },
    d: "M 42.121094 82.390625 C 40.96875 79.015625 40.300781 75.398438 40.300781 71.667969 C 40.300781 67.933594 40.96875 64.316406 42.0625 60.945312 L 42.03125 60.226562 L 24.9375 47.066406 L 24.378906 47.332031 C 20.671875 54.679688 18.542969 62.933594 18.542969 71.667969 C 18.542969 80.398438 20.671875 88.65625 24.378906 96 L 42.121094 82.390625 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google4)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.158508%,26.269531%,20.779419%)",
      fillOpacity: 1
    },
    d: "M 73.238281 38.417969 C 83.507812 38.417969 90.4375 42.8125 94.386719 46.488281 L 109.820312 31.550781 C 100.339844 22.816406 88.003906 17.457031 73.238281 17.457031 C 51.847656 17.457031 33.371094 29.621094 24.378906 47.332031 L 42.0625 60.945312 C 46.5 47.875 58.773438 38.417969 73.238281 38.417969 "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.1acbc6be.svg";
export { ForwardRef as ReactComponent };